import styled from 'styled-components';

export const GuideContainer = styled.div``

export const GuideCard = styled.div`
    margin: 30px 15px;
    padding: 20px;
    background-color: ${({theme}) => theme.colors.primary};
`